import { render } from "./NotificationEmail.vue?vue&type=template&id=4b17a486&scoped=true"
import script from "./NotificationEmail.vue?vue&type=script&lang=js"
export * from "./NotificationEmail.vue?vue&type=script&lang=js"

import "./NotificationEmail.vue?vue&type=style&index=0&id=4b17a486&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b17a486"]])

export default __exports__